export enum ErrorCode {
    OK = 'OK',
    ERROR_INTERNAL_PROBLEM = 'ERROR_INTERNAL_PROBLEM',

    // http-specific errors
    ERROR_HTTP = 'ERROR_HTTP',
    ERROR_BAD_REQUEST = 'ERROR_BAD_REQUEST',
    ERROR_JWT_EXPIRED = 'ERROR_JWT_EXPIRED',

    // crud-specific errors
    ERROR_ENTITY_NOT_FOUND = 'ERROR_ENTITY_NOT_FOUND',
    ERROR_UNPROCESSABLE_ENTITY = 'ERROR_UNPROCESSABLE_ENTITY',

    // auth errors
    ERROR_AUTH_TOKEN_PROBLEM = 'ERROR_AUTH_TOKEN_PROBLEM',
    ERROR_AUTH_CREDENTIALS_PROBLEM = 'ERROR_AUTH_CREDENTIALS_PROBLEM',
    ERROR_USER_MISSING_DATA = 'ERROR_USER_MISSING_DATA',

    // basket-specific errors
    MULTIPLE_BASKETS_FOUND = 'MULTIPLE_USER_BASKETS',
    ERROR_BASKET_OUTDATED = 'BASKET_OUT_OF_DATE',

    // Promotion errors
    PROMOTION_NOT_FOUND = 'PROMOTION_NOT_FOUND',
    NO_CODES_LEFT = 'NO_CODES_LEFT',
    PROMOTION_EXPIRED = 'PROMOTION_EXPIRED',

    // Rebookers error
    REBOOKER_STATUS_CHANGED = 'REBOOKER_STATUS_CHANGED',

    DATE_OF_BIRTH_NOT_FOUND = 'DATE_OF_BIRTH_NOT_FOUND',
    MONTH_NOT_FOUND = 'MONTH_NOT_FOUND',

    ALREADY_HAS_BOOKING = 'ALREADY_HAS_BOOKING',
}
